export default __webpack_public_path__ + "static/media/download-app-store.cda9b210.svg";